import React, { useEffect, useRef, useState } from "react";
import { injectIntl, WrappedComponentProps } from "react-intl";
import { inject, observer } from "mobx-react";
import ProfileStore from "common/my-page/stores/profile/ProfileStore";
import TailwindIcon from "library/components/_tailwind/icon";
import TailwindFlex from "library/components/_tailwind/flex";
import "./styles.scss";

type Props = {
  version?: "default" | "landing";
  profileStore?: ProfileStore;
  isOpen?: boolean;
  onOpenChange?: (open: boolean) => void;
};

const CHAT_CONTAINER_CLASS = "__8x8Chat-Container";
const BUTTON_CLASS_NAME = "live_chat_button_8x8";
const POLL_INTERVAL = 500;

const LiveChat8x8: React.FC<Props & WrappedComponentProps> = ({
  version = "default",
  profileStore,
  isOpen,
  onOpenChange,
}) => {
  const { isStudio } = profileStore!;
  const [internalOpen, setInternalOpen] = useState(false);
  const isChatOpen = isOpen !== undefined ? isOpen : internalOpen;
  const isChatOpenRef = useRef(false);
  const onOpenChangeRef = useRef(onOpenChange);
  onOpenChangeRef.current = onOpenChange;

  const setChatOpen = (open: boolean) => {
    isChatOpenRef.current = open;
    if (onOpenChangeRef.current) onOpenChangeRef.current(open);
    else setInternalOpen(open);
  };

  useEffect(() => {
    isChatOpenRef.current = isChatOpen;
  }, [isChatOpen]);

  useEffect(() => {
    window["__8x8Chat"] = {
      uuid: "script_145427927765baa7a839aef5.72341446",
      tenant: "ZnJpZW5kZmluZGVybmV0d281MTkwMQ",
      channel: "Chat Cams Model Studio",
      channelUuid: "q1gIEfwuQaCu8VDnhURC9w",
      domain: "https://vcc-na15.8x8.com",
      path: "/.",
      buttonContainerId:
        "__8x8-chat-button-container-script_145427927765baa7a839aef5.72341446",
      align: "right",
    };

    const se = document.createElement("script");
    se.type = "text/javascript";
    se.async = true;
    se.src =
      window["__8x8Chat"].domain +
      window["__8x8Chat"].path +
      "/CHAT/common/js/chat.js";

    const os = document.getElementsByTagName("script")[0];
    os?.parentNode?.insertBefore(se, os);
  }, [isStudio]);

  useEffect(() => {
    const interval = setInterval(() => {
      const container = document.querySelector(
        `.${CHAT_CONTAINER_CLASS}`
      ) as HTMLElement | null;
      if (!container) return;

      if (isChatOpenRef.current) {
        if (container.style.height === "0px") {
          setChatOpen(false);
        } else {
          container.style.removeProperty("display");
        }
      } else {
        container.style.setProperty("display", "none", "important");
      }
    }, POLL_INTERVAL);

    return () => clearInterval(interval);
  }, []);

  const toggleLiveChat = () => {
    if (isChatOpen) {
      setChatOpen(false);
    } else {
      setChatOpen(true);
      const btn = document.querySelector(
        `.${BUTTON_CLASS_NAME} img`
      ) as HTMLImageElement;
      btn?.click();
    }
  };

  return (
    <>
      {version === "landing" ? (
        <li className='LandingCover__list-item dimelo_chat_hide_when_offline'>
          <span className={"LandingCover__list-item--chat"}></span>
          <button
            className='bg-blue-500 text-white text-sm px-8 py-1'
            onClick={toggleLiveChat}>
            Live Chat Support
          </button>
          <div className='absolute opacity-0 w-0 h-0'>
            <div
              className={BUTTON_CLASS_NAME}
              id='__8x8-chat-button-container-script_145427927765baa7a839aef5.72341446'></div>
          </div>
        </li>
      ) : (
        <TailwindFlex justifyContent='justify-center' alignItems='items-center'>
          <TailwindFlex>
            <TailwindIcon
              fontSize={"text-xl"}
              className={"text-main-color cursor-pointer"}
              name={"support"}
              onClick={toggleLiveChat}
            />
          </TailwindFlex>
          <TailwindFlex
            position='absolute'
            opacity='opacity-0'
            width={"w-0"}
            height={"h-0"}>
            <div
              className={BUTTON_CLASS_NAME}
              id='__8x8-chat-button-container-script_145427927765baa7a839aef5.72341446'></div>
          </TailwindFlex>
        </TailwindFlex>
      )}
    </>
  );
};
export default injectIntl(inject("profileStore")(observer(LiveChat8x8)));
